export enum AuthErrorCode {
    EXPIRED = 'expired',
    UNAUTHENTICATED = 'unauthenticated',
    UNAUTHORIZED = 'unauthorized',
    UNKNOWN = 'unknown',
    LOGOUT_REQUIRED = 'logout_required'
}
